if (!customElements.get('sticky-toc')) {
  customElements.define(
    'sticky-toc',
    class StickyToC extends HTMLElement {
      constructor() {
        super();
        this.links = [];
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.updatePosition = this.updatePosition.bind(this);
        this.header = document.querySelector('store-header.header');
        this.lastScrollY = window.scrollY;
      }

      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('.sticky-toc__link'));
       // console.log('Sticky TOC initialized with', this.links.length, 'links');
        
        // Log what anchor IDs we're looking for
        this.links.forEach(link => {
          const targetId = link.getAttribute('href').slice(1);
          const targetEl = document.getElementById(targetId);
         // console.log(`TOC link "${link.textContent}" -> target "${targetId}":`, targetEl ? 'FOUND' : 'NOT FOUND');
        });
        
        this.links.forEach((link) => link.addEventListener('click', this.handleClick));
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.handleScroll();

        // Initial position below header
        this.updatePosition();
      }

      disconnectedCallback() {
        this.links.forEach((link) => link.removeEventListener('click', this.handleClick));
        window.removeEventListener('scroll', this.handleScroll);
      }

      handleClick(event) {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').slice(1);
        const targetEl = document.getElementById(targetId);
        if (targetEl) {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      handleScroll() {
        const currentScrollY = window.scrollY;
        const isScrollingDown = currentScrollY > this.lastScrollY;
        
        // console.log(`🔄 TOC scroll: ${isScrollingDown ? 'DOWN' : 'UP'}, scrollY: ${currentScrollY}`);
      
        // Update TOC position based on header visibility and scroll direction
        this.updatePosition(isScrollingDown);
        
        let activeLink = null;
        let closestDistance = Infinity;
        
        // Find the section that's currently most visible/closest to the top
        for (const link of this.links) {
          const targetId = link.getAttribute('href').slice(1);
          const targetEl = document.getElementById(targetId);
          
          if (targetEl) {
            const rect = targetEl.getBoundingClientRect();
            const distanceFromTop = Math.abs(rect.top);
            
            // Section is in viewport or close to it
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              if (distanceFromTop < closestDistance) {
                closestDistance = distanceFromTop;
                activeLink = link;
              }
            }
          }
        }
        
        // Set the active link
        if (activeLink) {
          this.setActiveLink(activeLink);
        } else {
          this.clearActiveLinks();
        }
        
        this.lastScrollY = currentScrollY;
      }

      setActiveLink(activeLink) {
        this.links.forEach((link) =>
          link.classList.toggle('sticky-toc__link--active', link === activeLink)
        );
      }

      clearActiveLinks() {
        this.links.forEach((link) => link.classList.remove('sticky-toc__link--active'));
      }

      updatePosition(isScrollingDown) {
        if (!this.header) return;
        
        const headerRect = this.header.getBoundingClientRect();
        const oldTop = this.style.top;
        
        // console.log(`📍 Header rect.top: ${headerRect.top}, current TOC top: ${oldTop}`);
        
        if (isScrollingDown) {
          // Scrolling down - use immediate positioning for responsive header appearance
          if (headerRect.top >= 0) {
            this.style.top = `${headerRect.bottom}px`;
          } else {
            this.style.top = '0px';
          }
        } else {
          // Scrolling up - smooth positioning that follows header animation
          if (headerRect.top >= 0) {
            // Header is fully visible
            // console.log(`✅ Header fully visible! Setting TOC to ${headerRect.bottom}px`);
            this.style.top = `${headerRect.bottom}px`;
          } else if (headerRect.top > -166) {
            // Header is animating into view - calculate proportional position
            const headerHeight = 166; // header height when fully visible
            const animationProgress = (headerRect.top + headerHeight) / headerHeight; // 0 to 1
            const tocPosition = Math.max(0, animationProgress * headerHeight);
            // console.log(`🎬 Header animating (${headerRect.top}px), TOC smooth position: ${tocPosition}px`);
            this.style.top = `${tocPosition}px`;
          } else {
            // Header is fully hidden
            // console.log(`❌ Header fully hidden (${headerRect.top}), TOC at 0px`);
            this.style.top = '0px';
          }
        }
      }
    }
  );
}